import {queryOptions} from '@tanstack/react-query';
import {journalRetrieve, journalList} from 'api/v2';
import type {JournalListParams} from 'api/v2';

export const journalQueryKeys = {
  all: () => ['journal'],
  detail: (id: string) => [...journalQueryKeys.all(), 'detail', id],
  journalList: (params: JournalListParams) => [
    ...journalQueryKeys.all(),
    'list',
    params,
  ],
};

const journalDetail = (id: string) =>
  queryOptions({
    queryKey: journalQueryKeys.detail(id),
    queryFn: () => journalRetrieve(id),
    select: (data) => data.data,
  });

const userJournals = (params: JournalListParams) =>
  queryOptions({
    queryKey: journalQueryKeys.journalList(params),
    queryFn: () => journalList(params),
    select: (data) => data.data,
  });

export const journalQueryOptions = {
  detail: journalDetail,
  userJournals,
};
